import {
    computePosition,
    autoUpdate,
    detectOverflow,
    offset,
    flip,
} from '@floating-ui/dom';
import Fuse from 'fuse.js';

function initSelect(referenceSelector, floatingSelector) {
    const referenceEl = document.querySelector(referenceSelector);
    const floatingEl = document.querySelector(floatingSelector);

    function update() {
        computePosition(referenceEl, floatingEl, {
            placement: 'bottom-start',
            middleware: [offset(5), flip()],
        }).then(({ x, y, placement, middlewareData }) => {
            console.log(x, y);
            Object.assign(floatingEl.style, {
                left: `${x}px`,
                top: `${y}px`,
            });
        });
    }

    function showTooltip() {
        floatingEl.classList.toggle('hidden');
        update();
    }

    function hideTooltip() {
        floatingEl.classList.add('hidden');
    }

    [
        ['click', showTooltip],
        // ['blur', hideTooltip],
    ].forEach(([event, listener]) => {
        console.log(event);
        referenceEl.addEventListener(event, listener, true);
    });
}

window.initSelect = initSelect;
